export default {
  YOUR_EVENTS: 'Your events',
  ADD_EVENTS: 'Add event',
  NO_EVENTS: 'You do not have any events added yet!',
  ENTER: 'Enter',
  EVENT_NAME: 'Event name',
  START_DATE: 'Start date',
  END_DATE: 'End date',
  LOCATION: 'Location',
  TIMEZONE: 'Timezone',
  EVENT_CONFIG: 'Event config',
  API_KEY: 'API key',
  ARCHIVE_DAYS: 'Archive days',
  ARCHIVE_DAYS_LABEL: 'Days to archive after event end',
  GDPR_CONFIG: 'GDPR config',
  GDPR_CONSENT: 'GDPR consent',
  GDPR_TITLE: 'GDPR title',
  GDPR_DESC: 'GDPR description',
  GDPR_APPROVE_LABEL: 'GDPR approve button label',
  GDPR_CANCEL_LABEL: 'GDPR cancel button label',
  ADD_EVENT: 'Add event',
  ADD_EVENT_SUCCESS: 'Your event has been created successfully!'
}
